import type { FullMode } from '../../domain/Mode'
import type { StopType } from '../../domain/Stop'
import type { AccountingObjectType } from '../domain/AccountingObjectType'
import type { PriceItemType } from '../domain/PriceItemType'

export type RawPriceItemType = {
  uuid: string
  label: string
  standard_code?: string
  description?: string
  stops_relationship?: Array<StopType>
  modes?: Array<FullMode>
  usage?: Array<AccountingObjectType>
}

export function mapApiToPriceItemType(priceItemType: RawPriceItemType): PriceItemType {
  return {
    uuid: priceItemType.uuid,
    label: priceItemType.label,
    stopsRelationship: priceItemType.stops_relationship,
  }
}
